import React, { useCallback, useMemo } from 'react';
import { format as formatDate } from 'date-fns';
import TimePicker from '.';
import {
  convertTo24HourFormat,
  convertToFormat,
  resolvePickerTimeFormat,
} from '../rangePicker/queries';
import type { TimePicker24HourProps } from './types';

function TimePicker24Hour({
  value,
  discreteTimeOptions,
  format,
  step,
  onChange,
  date,
  minTime,
  maxTime,
  onDateTimeChange,
}: TimePicker24HourProps) {
  const displayFormat = resolvePickerTimeFormat(format);
  const referenceDate = useMemo(
    () => date ?? new Date(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [date?.getTime()],
  );

  const displayValue = useMemo(
    () => convertToFormat(value, displayFormat, referenceDate),
    [value, displayFormat, referenceDate],
  );

  const onChangeTimePicker = useCallback(
    (timeString, event, boundedDate?: Date) => {
      if (onDateTimeChange && boundedDate) {
        onDateTimeChange(boundedDate);
        return;
      }

      const time24 = boundedDate
        ? formatDate(boundedDate, 'HH:mm')
        : convertTo24HourFormat(timeString, displayFormat, referenceDate);

      onChange(time24, event, boundedDate);
    },
    [displayFormat, onChange, onDateTimeChange, referenceDate],
  );

  return (
    <TimePicker
      showInput={false}
      onChange={onChangeTimePicker}
      //  @ts-ignore
      discreteTimeOptions={discreteTimeOptions}
      value={String(displayValue ?? '')}
      format={displayFormat}
      // @ts-ignore
      step={step}
      date={date}
      minTime={minTime}
      maxTime={maxTime}
    />
  );
}

export default TimePicker24Hour;
